import router from 'Router'

// const createNetworkErrorPage = () => {
//   router.addRoute({
//     path: '/network-error',
//     name: 'network-error',
//     component: () => import(/* webpackChunkName: "network-error" */ 'Pages/NetworkErrorPage'),
//   })
// }

const networkErrorPage = {
  name: 'network-error',
  params: { isError: true },
}

const getCardModalPageName = () => {
  let openRoute = ''
  const route = router.currentRoute.name

  switch (route) {
    case 'dashboard-team':
      openRoute = 'dashboard-team-modal'
      break
    case 'dashboard-client':
      openRoute = 'client-dashboard-modal'
      break
    case 'cards-listing':
      openRoute = 'cards-listing-modal'
      break
  }
  return openRoute
}

export { networkErrorPage, getCardModalPageName }
